import { Injectable } from '@angular/core';

import { CamBaseGridService, CamGridGraphConfig } from '@camelot/core';
import { GraphEndpoint } from '@camelot/server';

import { InvoiceGridRow } from './dto/invoice-grid-row';

const graphEndpoint: GraphEndpoint = {
  clientName: 'invoiceService',
  endpoint: 'invoice',
};

@Injectable({
  providedIn: 'root',
})
export class CamInvoiceGridService extends CamBaseGridService<InvoiceGridRow> {
  protected _graphEndpoint = graphEndpoint;

  protected _gridGraph: CamGridGraphConfig = {
    entity: 'Invoice',
    idArg: 'invoiceId',
    rowFields: () =>
      [
        'id',
        'parentId',
        'index',
        'hasChildren',
        'hidden',
        'rowType',
        'description',
        'quantity',
        'unit',
        'unitSellingPrice',
        'unitCostPrice',
        'exclVatTotal',
        'order',
        'compositionPath',
        'accountNumber',
        'analyticalAccount',
        'vatLevelId',
        'appliedFromDeposit',
      ].join(' '),
  };

  constructor() {
    super();
    super.registerRoutes({ graphEndpoint: this._graphEndpoint });
  }
}
